import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";
import { Loader2, Lock } from "lucide-react";
import { IMAGES } from "../../data/site";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(form.email, form.password);
      nav("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="admin-login-page">
      <div className="hidden lg:block relative">
        <img src={IMAGES.alleppeyAerial} alt="Kerala" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-emerald-dark/60" />
        <div className="relative z-10 p-12 h-full flex flex-col justify-end text-cream">
          <span className="font-serif text-4xl font-light">Kerala Holidays Connect</span>
          <p className="text-cream/70 mt-2">Admin Console · Manage enquiries & blog</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-cream">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <span className="w-12 h-12 bg-emerald text-cream flex items-center justify-center mb-6"><Lock className="w-5 h-5" /></span>
          <h1 className="font-serif text-4xl font-light text-emerald">Welcome back</h1>
          <p className="text-ink/50 mt-2 mb-8">Sign in to manage your website.</p>
          {error && <p className="bg-red-50 text-red-700 text-sm p-3 mb-4" data-testid="login-error">{error}</p>}
          <input required type="email" placeholder="Email" value={form.email} onChange={set("email")} className="w-full bg-transparent border-b border-ink/20 py-3 mb-5 focus:outline-none focus:border-emerald" data-testid="login-email" />
          <input required type="password" placeholder="Password" value={form.password} onChange={set("password")} className="w-full bg-transparent border-b border-ink/20 py-3 mb-8 focus:outline-none focus:border-emerald" data-testid="login-password" />
          <button type="submit" disabled={loading} className="w-full bg-emerald text-cream py-4 text-xs uppercase tracking-[0.2em] font-semibold hover:bg-gold transition-colors flex items-center justify-center gap-2" data-testid="login-submit">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
